import { MediaPlatform } from '#/types'

type MediaPlatformLabelValue = null | number | string | string[] | undefined

/**
 * 将业务侧媒体平台别名归一为系统字典 value。
 * 例如自动规则契约中的 meta 对应远程字典 facebook。
 */
export function normalizeMediaPlatformDictValue(
  value: MediaPlatformLabelValue,
): MediaPlatformLabelValue {
  if (Array.isArray(value)) {
    return value.map((item) => {
      const normalized = normalizeMediaPlatformDictValue(item)
      return typeof normalized === 'string' || typeof normalized === 'number'
        ? normalized
        : item
    })
  }

  if (typeof value !== 'string') {
    return value
  }

  if (value.trim().toLowerCase() === 'meta') {
    return MediaPlatform.FACEBOOK
  }

  return value
}

/**
 * 将系统字典 value 转为自动规则契约值。
 * 例如远程字典 facebook 对应自动规则契约 meta。
 */
export function toAutoRuleMediaPlatformValue(
  value: null | number | string | undefined,
): string | undefined {
  if (value === undefined || value === null) {
    return undefined
  }

  const normalized = String(value).trim()
  if (normalized === '') {
    return undefined
  }

  if (normalized.toLowerCase() === MediaPlatform.FACEBOOK) {
    return 'meta'
  }

  return normalized
}
